import regexPatterns from './regexPatterns'

export const formatHtml = (html) => {
    try {
        const constants = {
            indentChar: '  ',
            selfClosingSlash: '/>',
            commentStart: '<!',
            closingTagStart: '</',
            tagStart: '<'
        }
        let result = ''
        let indentLevel = 0
        html = html.replace(regexPatterns.removeNewlines, '').replace(regexPatterns.removeTagWhitespace, '><').trim()
        const tokens = html.split(regexPatterns.htmlTokenSplitter).filter(Boolean)

        tokens.map(token => {
            if (regexPatterns.closingTag.test(token)) {
                indentLevel = Math.max(indentLevel - 1, 0)
            }
            result += constants.indentChar.repeat(indentLevel) + token.trim() + '\n'
            if (
                token.startsWith(constants.tagStart) &&
                !token.startsWith(constants.closingTagStart) &&
                !token.startsWith(constants.commentStart) &&
                !token.endsWith(constants.selfClosingSlash)
            ) {
                indentLevel++
            }
        })

        return result.trim()
    } catch (e) {
        return html
    }
}
